import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputProps", "label", "name", "placeholder", "validate"];
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputStaticLabel } from 'foundations-components/transitional/components/InputStaticLabel';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FFInputStaticLabelControl(_ref) {
  let {
      inputProps = {},
      label,
      name,
      placeholder,
      validate = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input,
    meta
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, {
    error: meta.touched && meta.error,
    validationMessage: meta.touched && meta.error,
    children: /*#__PURE__*/_jsx(InputStaticLabel, {
      text: label,
      children: /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, inputProps, {
        placeholder: placeholder
      }))
    })
  }));
}